// ie polyfill
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'
import appConfig from '@/config/app.config'

import bootstrap from './core/bootstrap'
import './core/use'
// 去掉权限校验，把菜单全部显示出来
// import './permission' // permission control
import './utils/filter' // global filter
import VueAMap from 'vue-amap'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueCropper from 'vue-cropper'
// import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Vue.use(ElementUI,{size:'mini'})

Vue.use(VueCropper)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.config.productionTip = false

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

// 高德地图
Vue.use(VueAMap)

VueAMap.initAMapApiLoader({
  key: appConfig.AMAP_KEY,
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
